import { Component, EventEmitter, Output, ViewChild, Injectable } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Dayjs } from 'dayjs';
import { DaterangepickerDirective, LocaleConfig } from 'ngx-daterangepicker-material';
import { Subject, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { LocaleConfigDate } from 'src/app/constants/date-config.const';
import { SHOW_PER_PAGE_WEBHOOK } from 'src/app/constants/pagination.const';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';
import { RESEND_WEBHOOK, WEBHOOK_PAYMENT } from 'src/app/constants/endpoint.const';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ProfileService } from 'src/app/services/profile.service';

interface StatusItem {
  id: string;
  label: string;
  value: string;
  checked: boolean;
}

interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

interface FilterOrder {
  start_date: string;
  end_date: string;
  search?: string;
  status?: string[];
  limit: number;
  offset: number;
  period: string;
}

@Component({
  selector: 'app-webhook',
  standalone: false,
  templateUrl: './webhook.component.html',
  styleUrl: './webhook.component.scss'
})
export class WebhookComponent {
  loading: boolean = true;
  isGetWebhook: boolean = false;

  constructor(
    private router: Router,
    private profileService: ProfileService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.isGetWebhook = this.profileService.getRoLevel() === 3;
    this.profileService.getRoLevel$().subscribe((level) => {
      this.isGetWebhook = level === 3;
    });
  }

  upgradeToEnterprise() {
    this.router.navigate(['/subscriptions']);
  }
}
